export default __webpack_public_path__ + "static/media/dmail-white.ab21f1b1.svg";